export enum ENUM__dto_class_name {
  /*
   * BASE
   */

  ABSTRACT = 'ABSTRACT',

  FILE_DATA = 'FILE_DATA',
  OBJECT = 'OBJECT',
  MAP_SERIALIZABLE = 'MAP_SERIALIZABLE',
  MAP_SERIALIZABLE_ITEMS_HOLDER = 'MAP_SERIALIZABLE_ITEMS_HOLDER',
  POSITION = 'POSITION',

  PERFORMANCE_CAPTURE = 'PERFORMANCE_CAPTURE',

  RESPONSE_ERROR = 'RESPONSE_ERROR',
  RESPONSE_SUCCESS = 'RESPONSE_SUCCESS',

  IMAGE_GENERATED_METADATA_TOKEN = 'IMAGE_GENERATED_METADATA_TOKEN',

  RANGE_OF_TOKENS = 'RANGE_OF_TOKENS',
  RANGE_OF_NUMBERS = 'RANGE_OF_NUMBERS',

  REQUEST_TOKENS_ADD = 'REQUEST_TOKENS_ADD',
  REQUEST_TOKENS_DELETE = 'REQUEST_TOKENS_DELETE',
  REQUEST_TOKENS_UPDATE_VISIBILITY = 'REQUEST_TOKENS_UPDATE_VISIBILITY',
  REQUEST_VIEWER_ACTION = 'REQUEST_VIEWER_ACTION',

  /*
   * ADMIN
   */

  APP_INFO = 'APP_INFO',

  /*
   * AUTH
   */
  REQUEST_AUTH_REGISTER = 'REQUEST_AUTH_REGISTER',
  RESPONSE_AUTH_SUCCESS = 'RESPONSE_AUTH_SUCCESS',

  USER_AUTH_TOKEN = 'USER_AUTH_TOKEN',
  USER_CREDENTIALS = 'USER_CREDENTIALS',

  RESPONSE_AUTH_UNLINK = 'RESPONSE_AUTH_UNLINK',

  /*
   * COLLECTION
   */

  COLLECTION = 'COLLECTION',
  SPECIAL_COLLECTIONS_INFO = 'SPECIAL_COLLECTIONS_INFO',

  RESPONSE_COLLECTION_SPECIAL_INFO = 'RESPONSE_COLLECTION_IMAGES_IDS_IN_SPECIAL_COLLECTION',

  REQUEST_COLLECTION_UPDATE_VISIBILITY = 'REQUEST_COLLECTION_UPDATE_VISIBILITY',
  REQUEST_COLLECTION_UPDATE_NAME = 'REQUEST_COLLECTION_UPDATE_NAME',

  REQUEST_COLLECTION__IMAGE_ADD = 'REQUEST_COLLECTION__IMAGE_ADD',
  REQUEST_COLLECTION__IMAGE_DELETE = 'REQUEST_COLLECTION__IMAGE_DELETE',

  /*
   * MODELS
   */

  REQUEST_DIFFUSION_MODEL_UD_RENT = 'REQUEST_DIFFUSION_MODEL_UD_RENT',

  ML_ASSET_CONFIG = 'ML_ASSET_CONFIG',
  ML_ASSET = 'ML_ASSET',
  ML_ASSET_RESERVATION = 'ML_ASSET_RESERVATION',
  ML_ASSET_LORA_TAG_FREQUENCY = 'ML_ASSET_LORA_TAG_FREQUENCY',

  DIFFUSION_MODEL_UD_STATS = 'DIFFUSION_MODEL_UD_STATS',

  /*
   * GENERATION
   */

  COLOR = 'COLOR',

  REQUEST_GENERATION_DURATION_ADJUSTING_ADD = 'REQUEST_GENERATION_DURATION_ADJUSTING_ADD',
  REQUEST_GENERATION_GRID2D_UPDATE_SIZE = 'REQUEST_GENERATION_GRID2D_UPDATE_SIZE',

  REQUEST_GENERATION_START = 'REQUEST_GENERATION_START',
  REQUEST_GENERATION_UPDATE = 'REQUEST_GENERATION_UPDATE',
  REQUEST_GENERATION_ADD_DURATION = 'REQUEST_GENERATION_ADD_DURATION',
  REQUEST_GENERATION_UPDATE_NAME = 'REQUEST_GENERATION_UPDATE_NAME',
  REQUEST_GENERATION_CREATE = 'REQUEST_GENERATION_CREATE',
  REQUEST_GENERATION_CREATE_FOR_FIELD_CONSUMER = 'REQUEST_GENERATION_CREATE_FOR_FIELD_CONSUMER',
  REQUEST_GENERATION__CONSUME_CONTENT = 'REQUEST_GENERATION__CONSUME_CONTENT',

  USER_TASK = 'USER_TASK',
  GENERATION = 'GENERATION',
  GENERATION_TOOL = 'GENERATION_TOOL',
  GENERATION_TOOL_GRID2D_VIEW = 'GENERATION_TOOL_GRID2D_VIEW',

  TOKEN = 'TOKEN',
  TOKEN_CREATE_DATA = 'TOKEN_CREATE_DATA',
  GENERATION_SETTINGS_RANGE__SD1 = 'GENERATION_SETTINGS_RANGE__SD1',

  REQUEST_IMAGE_ASSET_SEGMENT = 'REQUEST_IMAGE_ASSET_SEGMENT',
  REQUEST_IMAGE_ASSET_FILTER = 'REQUEST_IMAGE_ASSET_FILTER',

  IMAGE_SIZE = 'IMAGE_SIZE',
  IMAGE_CROP_BOX = 'IMAGE_CROP_BOX',
  IMAGE_SEGMENT = 'IMAGE_SEGMENT',

  REQUEST_USER_TASK_UPDATE_VISIBILITY = 'REQUEST_USER_TASK_UPDATE_VISIBILITY',

  /*
   * GRAPH
   */

  GRAPH = 'GRAPH',
  GRAPH_META = 'GRAPH_META',
  GRAPH_EDGE = 'GRAPH_EDGE',

  /*
   * GRAPH INVOCATIONS
   */

  INVOCATION_META = 'INVOCATION_META',

  INVOCATION_GRID2D__VIEW = 'INVOCATION_GRID2D__VIEW',

  INVOCATION_IMAGE__EXTEND = 'INVOCATION_IMAGE__EXTEND',
  INVOCATION_IMAGE__PASTE_WITH_MASK = 'INVOCATION_IMAGE__PASTE_WITH_MASK',
  INVOCATION_IMAGE__MASK_BOOLEAN_TO_TENSOR = 'INVOCATION_IMAGE__MASK_BOOLEAN_TO_TENSOR',
  INVOCATION_IMAGE__CREATE_MASK_GRADIENT = 'INVOCATION_IMAGE__CREATE_MASK_GRADIENT',
  INVOCATION_IMAGE__VIEWPORT = 'INVOCATION_IMAGE__VIEWPORT',
  INVOCATION_IMAGE__COLOR_MAP = 'INVOCATION_IMAGE__COLOR_MAP',
  INVOCATION_IMAGE__TRIM_COLOR = 'INVOCATION_IMAGE__TRIM_COLOR',
  INVOCATION_IMAGE__SHARP = 'INVOCATION_IMAGE__SHARP',
  INVOCATION_IMAGE__SCALE = 'INVOCATION_IMAGE__SCALE',

  INVOCATION_LATENTS__CREATE_NOISE = 'INVOCATION_LATENTS__CREATE_NOISE',

  INVOCATION_VISION_CV2__LINE__CANNY = 'INVOCATION_VISION_CV2__LINE__CANNY',
  INVOCATION_VISION_CV2__LINE__CANNY_AUTO = 'INVOCATION_VISION_CV2__LINE__CANNY_AUTO',
  INVOCATION_VISION_CV2__LINE__CANNY_SEMI_AUTO = 'INVOCATION_VISION_CV2__LINE__CANNY_SEMI_AUTO',
  INVOCATION_VISION_ML__LINE__HED = 'INVOCATION_VISION_ML__LINE__HED',

  INVOCATION_VISION_ML__REMBG = 'INVOCATION_VISION_ML__REMBG',

  INVOCATION_VISION_ML__SEGMENT_SEGFORMER = 'INVOCATION_VISION_ML__SEGMENT_SEGFORMER',
  INVOCATION_VISION_ML__DEPTH_ANYTHING = 'INVOCATION_VISION_ML__DEPTH_ANYTHING',

  INVOCATION_SD__TEXT_ENCODER = 'INVOCATION_SD__TEXT_ENCODER',
  INVOCATION_SD__TEXT_ENCODER_MASKED = 'INVOCATION_SD__TEXT_ENCODER_MASKED',
  INVOCATION_SD__DENOISE_LATENTS_PIPELINE = 'INVOCATION_SD__DENOISE_LATENTS_PIPELINE',
  INVOCATION_SD__LATENTS_TO_IMAGE = 'INVOCATION_SD__LATENTS_TO_IMAGE',
  INVOCATION_SD__IMAGE_TO_LATENTS = 'INVOCATION_SD__IMAGE_TO_LATENTS',
  INVOCATION_SD__LORA_SELECT = 'INVOCATION_SD__LORA_SELECT',
  INVOCATION_SD__CONTROL_NET = 'INVOCATION_SD__CONTROL_NET',
  INVOCATION_SD__IP_ADAPTER = 'INVOCATION_SD__IP_ADAPTER',
  INVOCATION_SD__T2I_ADAPTER = 'INVOCATION_SD__T2I_ADAPTER',

  INVOCATION_SPANDREL__UPSCALER = 'INVOCATION_SPANDREL__UPSCALER',
  INVOCATION_SPANDREL__UPSCALER_TO_SIDE = 'INVOCATION_SPANDREL__UPSCALER_TO_SIDE',

  INVOCATION_TOOL_VIEW__INFO = 'INVOCATION_TOOL_VIEW__INFO',

  /*
   * GRAPH FIELDS
   */
  GRAPH_FIELD_META_INFO = 'GRAPH_FIELD_META_INFO',

  GRAPH_FIELD_ANY = 'GRAPH_FIELD_ANY',
  GRAPH_FIELD_ANY__ML_ASSET = 'GRAPH_FIELD_ANY__ML_ASSET',
  GRAPH_FIELD_ANY__LIST = 'GRAPH_FIELD_ANY__LIST',

  GRAPH_FIELD_PRIMITIVE_INT = 'GRAPH_FIELD_INT',
  GRAPH_FIELD_PRIMITIVE_INT_IMAGE_SIDE = 'GRAPH_FIELD_PRIMITIVE_INT_IMAGE_SIDE',
  GRAPH_FIELD_PRIMITIVE_FLOAT = 'GRAPH_FIELD_PRIMITIVE_FLOAT',

  GRAPH_FIELD_PRIMITIVE_STRING = 'GRAPH_FIELD_PRIMITIVE_STRING',
  GRAPH_FIELD_PRIMITIVE_STRING_ENUM = 'GRAPH_FIELD_PRIMITIVE_STRING_ENUM',
  GRAPH_FIELD_PRIMITIVE_STRING_UUID = 'GRAPH_FIELD_STRING_UUID',
  GRAPH_FIELD_PRIMITIVE_STRING_HASH_SHA256 = 'GRAPH_FIELD_PRIMITIVE_STRING_HASH_SHA256',
  GRAPH_FIELD_PRIMITIVE_STRING_HASH_ML_ASSET = 'GRAPH_FIELD_PRIMITIVE_STRING_HASH_ML_ASSET',
  GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_GENERATED = 'GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_GENERATED',
  GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_UPLOADED = 'GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_UPLOADED',

  GRAPH_FIELD_PRIMITIVE_BOOL = 'GRAPH_FIELD_PRIMITIVE_BOOL',
  GRAPH_FIELD_PRIMITIVE_SEED = 'GRAPH_FIELD_PRIMITIVE_SEED',

  GRAPH_FIELD_SD__CONDITIONING = 'GRAPH_FIELD_SD__CONDITIONING',
  GRAPH_FIELD_SD__CONDITIONING_MASKED = 'GRAPH_FIELD_SD__CONDITIONING_MASKED',
  GRAPH_FIELD_SD__LIST_CONDITIONING = 'GRAPH_FIELD_SD__LIST_CONDITIONING',
  GRAPH_FIELD_SD__LIST_CONDITIONING_MASKED = 'GRAPH_FIELD_SD__LIST_CONDITIONING_MASKED',

  /*
   *
   */
  GRAPH_FIELD_ML_ASSET_CONTROL_NET = 'GRAPH_FIELD_ML_ASSET_CONTROL_NET',
  GRAPH_FIELD_ML_ASSET_CLIP = 'GRAPH_FIELD_ML_ASSET_CLIP',
  GRAPH_FIELD_ML_ASSET_LORA = 'GRAPH_FIELD_ML_ASSET_LORA',
  GRAPH_FIELD_ML_ASSET_VAE = 'GRAPH_FIELD_ML_ASSET_VAE',

  GRAPH_FIELD_ML_ASSET_UNET = 'GRAPH_FIELD_ML_ASSET_UNET',
  GRAPH_FIELD_ML_ASSET_UNET_FREE_U = 'GRAPH_FIELD_ML_ASSET_UNET_FREE_U',

  GRAPH_FIELD_ML_ASSET_IP_ADAPTER = 'GRAPH_FIELD_ML_ASSET_IP_ADAPTER',
  GRAPH_FIELD_ML_ASSET_T2I_ADAPTER = 'GRAPH_FIELD_ML_ASSET_T2I_ADAPTER',

  GRAPH_FIELD_IMAGE_ASSET = 'GRAPH_FIELD_IMAGE_ASSET',
  GRAPH_FIELD_IMAGE_SIZE = 'GRAPH_FIELD_IMAGE_SIZE',
  GRAPH_FIELD_IMAGE_CROP_BOX = 'GRAPH_FIELD_IMAGE_CROP_BOX',
  GRAPH_FIELD_IMAGE_SEGMENTS = 'GRAPH_FIELD_IMAGE_SEGMENTS',

  GRAPH_FIELD_TOKEN = 'GRAPH_FIELD_TOKEN',

  GRAPH_FIELD_GRID2D_MODE__LORA_VS_LORA = 'GRAPH_FIELD_GRID2D_MODE__LORA_VS_LORA',
  GRAPH_FIELD_GRID2D_MODE__LORA_AFTER_LORA = 'GRAPH_FIELD_GRID2D_MODE__LORA_AFTER_LORA',
  GRAPH_FIELD_GRID2D_MODE__SINGLE_LORA_GENERATION = 'GRAPH_FIELD_GRID2D_MODE__SINGLE_LORA_GENERATION',
  GRAPH_FIELD_GRID2D_MODE__ALL_LORAS_EXCEPT_ONE = 'GRAPH_FIELD_GRID2D_MODE__ALL_LORAS_EXCEPT_ONE',

  GRAPH_FIELD_GRID2D_MODE__TOKEN_VS_TOKEN = 'GRAPH_FIELD_GRID2D_MODE__TOKEN_VS_TOKEN',
  GRAPH_FIELD_GRID2D_MODE__TOKEN_AFTER_TOKEN = 'GRAPH_FIELD_GRID2D_MODE__TOKEN_AFTER_TOKEN',
  GRAPH_FIELD_GRID2D_MODE__SINGLE_TOKEN_GENERATION = 'GRAPH_FIELD_GRID2D_MODE__SINGLE_TOKEN_GENERATION',
  GRAPH_FIELD_GRID2D_MODE__ALL_TOKENS_EXCEPT_ONE = 'GRAPH_FIELD_GRID2D_MODE__ALL_TOKENS_EXCEPT_ONE',

  GRAPH_FIELD_TENSOR_LATENTS_MASKED = 'GRAPH_FIELD_TENSOR_LATENTS_MASKED',
  GRAPH_FIELD_TENSOR_LATENTS = 'GRAPH_FIELD_TENSOR_LATENTS',
  GRAPH_FIELD_TENSOR_IMAGE = 'GRAPH_FIELD_TENSOR_IMAGE',
  GRAPH_FIELD_TENSOR_IMAGE_MASK_BOOLEAN = 'GRAPH_FIELD_TENSOR_IMAGE_MASK_BOOLEAN',

  GRAPH_FIELD_LIST__TOKEN = 'GRAPH_FIELD_LIST__TOKEN',
  GRAPH_FIELD_LIST__FLOAT = 'GRAPH_FIELD_LIST__FLOAT',
  GRAPH_FIELD_LIST__IMAGE_ASSET = 'GRAPH_FIELD_LIST__IMAGE_ASSET',
  GRAPH_FIELD_LIST__TENSOR_IMAGE_MASK_BOOLEAN = 'GRAPH_FIELD_LIST__TENSOR_IMAGE_MASK_BOOLEAN',

  GRAPH_FIELD_LIST__LORA = 'GRAPH_FIELD_LIST__LORA',
  GRAPH_FIELD_LIST__IP_ADAPTER = 'GRAPH_FIELD_LIST__IP_ADAPTER',
  GRAPH_FIELD_LIST__T2I_ADAPTER = 'GRAPH_FIELD_LIST__T2I_ADAPTER',
  GRAPH_FIELD_LIST__CONTROL_NET = 'GRAPH_FIELD_LIST__CONTROL_NET',

  GRAPH_FIELD_LIST_FLOAT_DYNAMIC = 'GRAPH_FIELD_LIST_FLOAT_DYNAMIC',

  /*
   * ERRORS
   */

  ERROR_GRAPH_EDGE = 'ERROR_GRAPH_EDGE',
  ERROR_GRAPH_NODE = 'ERROR_GRAPH_NODE',
  ERROR_GRAPH_FIELD = 'ERROR_GRAPH_FIELD',
  ERROR_GRAPH_GRAPH = 'ERROR_GRAPH_GRAPH',

  /*
   * GENERATION PRICE
   */
  REQUEST_GENERATION_PRICE_GET = 'REQUEST_GENERATION_PRICE_GET',

  GENERATION_PRICE_DATA = 'GENERATION_PRICE_DATA',

  /*
   * GRID2D
   */

  REQUEST_GRID2D_GET_BY_ENTITY_TYPE_AND_ID = 'REQUEST_GRID2D_GET_BY_ENTITY_TYPE_AND_ID',
  REQUEST_GRID2D_CHUNK_LOAD_CELLS = 'REQUEST_GRID2D_CHUNK_LOAD_CELLS',
  REQUEST_GRID2D_DOWNLOAD_IMAGES = 'REQUEST_GRID2D_DOWNLOAD_IMAGES',
  RESPONSE_GRID2D_DOWNLOAD_IMAGES = 'RESPONSE_GRID2D_DOWNLOAD_IMAGES',

  GRID2D = 'GRID2D',
  GRID2D_GENERATION = 'GRID2D_GENERATION',

  GRID2D_VIRTUAL = 'GRID2D_VIRTUAL',

  GRID2D_FLOAT_VISIBLE_AREA = 'GRID2D_FLOAT_VISIBLE_AREA',

  GRID2D_CHUNK = 'GRID2D_CHUNK',
  GRID2D_CHUNK_GENERATION = 'GRID2D_CHUNK_GENERATION',

  GRID2D_CELL_GENERATION = 'GRID2D_CELL_GENERATION',
  GRID2D_CELL = 'GRID2D_CELL',

  /*
   * IMAGE
   */

  IMAGE_META__IN_WORKSPACE = 'META_IMAGE_USE__IN_WORKSPACE',

  IMAGE_META__GRID2D_CELL_COLLECTION = 'IMAGE_META__GRID2D_CELL_COLLECTION',
  IMAGE_META__GRID2D_CELL_GENERATION = 'IMAGE_META__GRID2D_CELL_GENERATION',

  IMAGE_META__GRAPH_FIELD = 'IMAGE_META__GRAPH_FIELD',
  IMAGE_META__GRAPH_FIELD_GENERATED = 'IMAGE_META__GRAPH_FIELD_GENERATED',

  IMAGE_ASSET = 'IMAGE_ASSET',

  IMAGE_ASSET__MASKED_CROPPED = 'IMAGE_ASSET__MASKED_CROPPED',

  /*
   * IMAGE AI DESCRIPTION
   */
  REQUEST_IMAGE_AI_DESCRIPTION_CREATE_OR_TRANSLATE = 'REQUEST_IMAGE_AI_DESCRIPTION_TRANSLATE',

  IMAGE_AI_DESCRIPTION = 'IMAGE_AI_DESCRIPTION',

  /*
   * MODELS TABLE
   */

  DIFFUSION_MODELS_TABLE_UD = 'DIFFUSION_MODELS_TABLE_UD',
  DIFFUSION_MODELS_TABLE_PAGE_UD = 'DIFFUSION_MODELS_TABLE_PAGE_UD',
  DIFFUSION_MODELS_TABLE_PAGE_SETTINGS_UD = 'DIFFUSION_MODELS_TABLE_PAGE_SETTINGS_UD',

  /*
   * SEARCH
   */

  SEARCH_SETTINGS = 'SEARCH_SETTINGS',

  /*
   *  SETTINGS WORKSPACE
   */

  SETTINGS_WORKSPACE = 'SETTINGS_WORKSPACE',

  /*
   * USER
   */

  USER = 'USER',

  USER_SUPPORT_MESSAGE = 'USER_SUPPORT_MESSAGE',

  USER_SETTINGS = 'USER_SETTINGS',

  USER_TUTORIAL_PROGRESS = 'USER_TUTORIAL_PROGRESS',

  /*
   * RUNPOD VPS_INSTANCE
   */
  VPS_INSTANCE = 'VPS_INSTANCE',

  /*
   * VISION
   */

  /*
   * WORD TRANSLATED
   */
  REQUEST_WORDS_TRANSLATE_FROM_ENGLISH = 'REQUEST_WORDS_TRANSLATE_FROM_ENGLISH',

  WORD = 'WORD',
  WORD_WITH_CONTEXT = 'WORD_WITH_CONTEXT',
  WORD_METADATA = 'WORD_METADATA',

  WORD_WITH_RELATED_WORDS = 'WORD_WITH_RELATED_WORDS',
  WORDS_VOCABULARY = 'WORDS_VOCABULARY',

  /*
   * WORD WITH RELATED WORDS
   */
  REQUEST_WORD_WITH_RELATED_WORDS_GET = 'REQUEST_WORD_WITH_RELATED_WORDS_GET',
  REQUEST_WORD_WITH_RELATED_WORDS_CREATE = 'REQUEST_WORD_WITH_RELATED_WORDS_CREATE',
  REQUEST_WORD_WITH_RELATED_WORDS_TRANSLATE_FROM_ENGLISH = 'REQUEST_WORD_WITH_RELATED_WORDS_TRANSLATE_FROM_ENGLISH',

  /*
   * WORKSPACE BILLING
   */

  REQUEST_BUY_CREDITS = 'REQUEST_BUY_CREDITS',

  WORKSPACE_PAYMENT_TRANSACTION_STRIPE = 'WORKSPACE_PAYMENT_TRANSACTION_STRIPE',
  WORKSPACE_CREDIT_TRANSACTION = 'WORKSPACE_CREDIT_TRANSACTION',
  WORKSPACE_BALANCE = 'WORKSPACE_BALANCE',

  WORKSPACE_SUBSCRIPTION = 'WORKSPACE_SUBSCRIPTION',

  /*
   * WORKSPACE
   */

  REQUEST_IMAGES_UPLOAD = 'REQUEST_IMAGES_UPLOAD',

  REQUEST_WORKSPACE_USER_DELETE = 'REQUEST_WORKSPACE_USER_DELETE',

  REQUEST_WORKSPACE_USER_CREDITS_LIMIT_UPDATE_STATUS = 'REQUEST_WORKSPACE_USER_CREDITS_LIMIT_UPDATE_STATUS',
  REQUEST_WORKSPACE_USER_CREDITS_LIMIT_UPDATE = 'REQUEST_WORKSPACE_USER_CREDITS_LIMIT_UPDATE',
  REQUEST_WORKSPACE_USER_CREDITS_LIMIT_RESET = 'REQUEST_WORKSPACE_USER_CREDITS_LIMIT_RESET',

  REQUEST_WORKSPACE_CHILD_ENTITY_DELETE = 'REQUEST_WORKSPACE_CHILD_ENTITY_DELETE',
  REQUEST_WORKSPACE_CHILD_ENTITY_UPDATE_SHARE_STATUS = 'REQUEST_WORKSPACE_CHILD_ENTITY_SHARE_STATUS_UPDATE',
  REQUEST_WORKSPACE_UPDATE_AVATAR = 'REQUEST_WORKSPACE_UPDATE_AVATAR',

  REQUEST_WORKSPACE_USER_INVITATION_CREATE = 'REQUEST_WORKSPACE_USER_INVITATION_CREATE',
  REQUEST_WORKSPACE_USER_INVITATION_REPLY = 'REQUEST_WORKSPACE_USER_INVITATION_REPLY',
  REQUEST_WORKSPACE_USER_INVITATION_DELETE = 'REQUEST_WORKSPACE_USER_INVITATION_DELETE',

  REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_TRANSFER_CREATE = 'REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_TRANSFER_CREATE',
  REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_REPLY = 'REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_REPLY',
  REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_TRANSFER_DELETE = 'REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_TRANSFER_DELETE',

  WORKSPACE = 'WORKSPACE',
  WORKSPACE_USER_INVITATION = 'WORKSPACE_USER_INVITATION',
  WORKSPACE_USER = 'WORKSPACE_USER',

  WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL = 'WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL',

  WORKSPACE_ENTITY_WITH_GRID2D = 'WORKSPACE_ENTITY_WITH_GRID2D',
  WORKSPACE_CHILD_ENTITY = 'WORKSPACE_CHILD_ENTITY',
  WORKSPACE_CHILD_ENTITY_VIEWER = 'WORKSPACE_CHILD_ENTITY_VIWER',
}
